import React, { Fragment } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { AiOutlineUpload, AiOutlineHeart } from 'react-icons/ai';
import { isNil, uniq } from 'lodash';
import Img from '../../../../components/Img/Img';
import VideoPlayer from '../../../../components/VideoPlayer';
import prevIcon from '../../../../static/images/product/prodDetailPreview/prev.png';
import nextIcon from '../../../../static/images/product/prodDetailPreview/next.png';
import brandLikeBtn from '../../../../static/images/product/prodDetailPreview/btn-brand-like.png';
import infoIcon from '../../../../static/images/product/prodDetailPreview/info-icon.png';
import brandNotiyInfo from '../../../../static/images/product/prodDetailPreview/brand-notiy-info.png';
import zoomBtn from '../../../../static/images/product/prodDetailPreview/bnt-zoom.png';
import detailEmptyImg from '../../../../static/images/product/prodDetailPreview/detailEmptyImg.png';
import extraInfoToggleUp from '../../../../static/images/product/prodDetailPreview/extra-info-toggle-up.png';
import extraInfoToggleDown from '../../../../static/images/product/prodDetailPreview/extra-info-toggle-down.png';
import orderRightArrow from '../../../../static/images/product/prodDetailPreview/order-right-arrow.png';
import todayDeliveryBadgeIcon from '../../../../static/images/common/today_delivery_badge_icon.png';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';
import {
  PRODUCT_ATTACHMENT_TYPE,
  PRODUCT_DELIVERY_TYPE,
  PRODUCT_DELIVERY_TYPE_TEXT,
  PRODUCT_ORDER_MADE_TYPE_TEXT,
  PRODUCT_STATUS_TEXT,
  PRODUCT_CATEGORY_NAME,
  AVAILABLE_CHAIN_SHAPE_TAG_CATEGORY_NAME_LIST,
} from '../../../../constants/service/app/productConstants';
import { STORE_STATUS_TEXT } from '../../../../constants/service/app/brandConstants';
import { TAG_GROUP_KIND_NAME, TAG_GROUP_KIND } from '../../../../constants/service/app/tagConstants';
import { POINT_RATE } from '../../../../constants/service/app/pointConstants';
import { setDash, setPhoneFormat, setNumberWithComma, checkIsBetween } from '../../../../lib/common';
import { setDeliveryTypeInfo, setDeliveryTypeInfoContent } from '../../../../lib/utils/productUtils';
import './PreviewProductDetail.scss';

const PreviewProductDetail = (props) => {
  const {
    showActualValue,
    next,
    prev,
    extraToggle,
    isShowExtra,
    isShowDeliveryInfoLayer,
    imgPage,
    data,
    deliveryInfoLayerToggle,
    directDeliveryTimeAvailable,
  } = props;
  const {
    productImgList,
    storeImg,
    storeName,
    name,
    discountType,
    discountRate,
    originPrice,
    salesPrice,
    savingPoint,
    tagLinkData,
    relatedTagList,
    size,
    weight,
    isSelectMaterialEtcTag,
    categoryNameList = [],
    mainCategoryNameList = [],
    productNotice,
    detailImg = [],
    deliveryChargeJeju,
    deliveryChargeEtc,
    memo,
    line1,
    line2,
    asInform,
    caution,
    qualityAssurance,
    manufacturer,
    origin,
    asPhone,
    storePhone,
    kakaoAccount,
    deliveryType,
    isOrderMade,
    orderMadeDate,
    directDeliveryTimeLimit,
    status,
    storeStatus,
    isShowStatusValue = true,
    discountAvailable,
    likeCount,
    isTodayDelivery,
    showGeneralDeliveryInfo,
  } = data;

  return (
    <Fragment>
      <div className="product-preview-detail-modal">
        {isShowStatusValue && showActualValue ? (
          <div className="store-product-status-badge">
            <Tooltip title="상점 상태">
              {!isNil(storeStatus) ? <div className="store-status">{STORE_STATUS_TEXT[storeStatus]}</div> : null}
            </Tooltip>
            <Tooltip title="상품 상태">
              <div className="product-status">{PRODUCT_STATUS_TEXT[status]}</div>
            </Tooltip>
          </div>
        ) : null}

        <div className="product-preview-detail-view">
          {/* 이미지 영역(대표, 서브이미지) */}
          <div className="product-img-container">
            <Img className="product-img" src={productImgList[imgPage].url} />

            {/* 이전, 다음 버튼 */}
            <div className="swipe-controller">
              {imgPage > 0 && <Img clickAble={false} src={prevIcon} className="prev" onClick={() => prev()} />}
              {productImgList.length > 1 && imgPage < productImgList.length - 1 && (
                <Img clickAble={false} src={nextIcon} className="next" onClick={() => next()} />
              )}
            </div>
          </div>

          {/* 매장 정보 (매장명, 매장 대표이미지, 바로가기) */}
          <div className="brand-info">
            {storeImg ? (
              <Img clickAble={false} src={storeImg} className="brand-img" />
            ) : (
              <div className="brand-img empty"></div>
            )}
            <div className="brand-name">{storeName}</div>
            <Img clickAble={false} src={brandLikeBtn} className="brand-like-btn" />
          </div>

          {/* 제품 정보 (가격, 상품명) */}
          <div className="product-info">
            {isTodayDelivery ? (
              <div className="delivery-free-info is-today-delivery">
                <span>오늘출발</span>
              </div>
            ) : null}

            <div className="delivery-free-info">
              <span>무료배송</span>
            </div>

            <div className="name">
              {name ? (
                <span>{name}</span>
              ) : (
                <span>
                  <span className="star">*</span>상품명을 입력해주세요
                </span>
              )}
            </div>

            {/* 할인 o */}
            {!isNil(discountType) ? (
              !showActualValue || (showActualValue && discountAvailable) ? (
                <div className="price">
                  <span className="rate">{discountRate}%</span>
                  <span className="number">{setNumberWithComma(salesPrice)}</span>
                  <span className="unit">원</span>
                  <span className="origin">{setNumberWithComma(originPrice)}</span>
                </div>
              ) : (
                <div className="price">
                  <span className="number">{setNumberWithComma(originPrice)}</span>
                  <span className="unit">원</span>
                </div>
              )
            ) : null}

            {/* 할인 x */}
            {isNil(discountType) ? (
              <div className="price">
                <span className="number">{setNumberWithComma(originPrice)}</span>
                <span className="unit">원</span>
                {!originPrice && (
                  <div className="empty">
                    <span className="star">*</span>
                    <span>가격을 입력해주세요</span>
                  </div>
                )}
              </div>
            ) : null}

            <div className="point">
              {showActualValue && !discountAvailable ? Math.floor(originPrice * POINT_RATE) : savingPoint} 포인트 적립
            </div>
          </div>

          <div className="bar" />

          {/*배송 타입*/}
          {!isNil(deliveryType) || isTodayDelivery ? (
            <Fragment>
              <div className="product-delivery-type">
                <div className="product-delivery-type-info">
                  <span>배송안내 : </span>
                  {isTodayDelivery ? (
                    <Fragment>
                      <Img className="today-delivery-badge-icon" clickAble={false} src={todayDeliveryBadgeIcon} />
                      <Img clickAble={false} src={infoIcon} onClick={() => deliveryInfoLayerToggle()} />
                    </Fragment>
                  ) : (
                    <Fragment>
                      <span>
                        {deliveryType === PRODUCT_DELIVERY_TYPE.GENERAL_DELIVERY && isOrderMade
                          ? PRODUCT_ORDER_MADE_TYPE_TEXT
                          : deliveryType === PRODUCT_DELIVERY_TYPE.DIRECT_DELIVERY && directDeliveryTimeAvailable
                            ? PRODUCT_DELIVERY_TYPE_TEXT[PRODUCT_DELIVERY_TYPE.DIRECT_DELIVERY]
                            : PRODUCT_DELIVERY_TYPE_TEXT[PRODUCT_DELIVERY_TYPE.GENERAL_DELIVERY]}
                      </span>
                      {(deliveryType === PRODUCT_DELIVERY_TYPE.DIRECT_DELIVERY && directDeliveryTimeAvailable) ||
                      isOrderMade ? (
                        <Img clickAble={false} src={infoIcon} onClick={() => deliveryInfoLayerToggle()} />
                      ) : null}
                    </Fragment>
                  )}
                  <span className="store-inquiry-btn">
                    <span>브랜드에 문의하기</span>
                    <Img clickAble={false} src={orderRightArrow} />
                  </span>
                </div>

                {isTodayDelivery ? (
                  <div className="product-delivery-type-content">
                    <span className="description-label is-today-delivery">오늘출발 옵션 :</span>
                    <div className="description-content">
                      <div className="emphasize">오후 3시까지 주문시, 오늘 바로 배송 시작!</div>
                      <div>(주말/공휴일 주문건은 가장 빠른 영업일에 출발)</div>
                    </div>
                  </div>
                ) : null}

                {showGeneralDeliveryInfo ? (
                  <div className="product-delivery-type-content">
                    {isTodayDelivery ? <span className="description-label is-today-delivery">그 외 옵션 :</span> : null}
                    <div className="description-content">
                      {setDeliveryTypeInfo({
                        deliveryType,
                        isOrderMade,
                        orderMadeDate,
                        directDeliveryTimeLimit,
                        showActualValue,
                      })}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="bar" />
            </Fragment>
          ) : null}

          {/*공지사항 정보*/}
          {productNotice && productNotice.content ? (
            !showActualValue ||
            (showActualValue &&
              ((!productNotice.startDate && !productNotice.endDate) ||
                checkIsBetween(DATE_FORMAT.YMD_HM_DASH_FORMAT, productNotice.startDate, productNotice.endDate))) ? (
              <Fragment>
                <div className="product-notice">
                  <div className="product-notice-info">
                    <Img clickAble={false} src={brandNotiyInfo} />
                    <span>브랜드에서 알려드려요</span>
                  </div>
                  <div className="product-notice-content">{productNotice.content}</div>
                </div>

                <div className="bar" />
              </Fragment>
            ) : null
          ) : null}

          {/* 상세이미지 */}
          <div className="product-detail-img">
            <div className="zoom-btn">
              <Img clickAble={false} src={zoomBtn} />
            </div>

            {detailImg.length ? (
              detailImg.map((item, i) =>
                item.type === PRODUCT_ATTACHMENT_TYPE.VIDEO ? (
                  <VideoPlayer key={i} width={'100%'} height={'100%'} controls={true} url={item.url} />
                ) : (
                  <Img key={i} className="product-img" src={item.url} />
                ),
              )
            ) : (
              <Img className="product-img" src={detailEmptyImg} />
            )}
          </div>

          {/* 상품 상세 설명 */}
          <div className="product-detail-info">
            <div className="title">상품 상세 설명</div>

            {/* 1,2차 카테고리 */}
            <div>
              <div className="label">카테고리</div>
              <div className="text">
                {categoryNameList.length ? (
                  <span>{uniq(categoryNameList).join(', ')}</span>
                ) : (
                  <Fragment>
                    <span className="star">*</span>
                    <span>카테고리를 추가해주세요</span>
                  </Fragment>
                )}
              </div>
            </div>

            {/* 소재/베이스 태그 */}
            <div>
              <div className="label">{TAG_GROUP_KIND_NAME[TAG_GROUP_KIND.MATERIAL_BASE]}</div>
              <div className="text">
                {tagLinkData[TAG_GROUP_KIND.MATERIAL_BASE] && tagLinkData[TAG_GROUP_KIND.MATERIAL_BASE].length ? (
                  <span>{tagLinkData[TAG_GROUP_KIND.MATERIAL_BASE].join(',')}</span>
                ) : (
                  <Fragment>
                    <span className="star">*</span>
                    <span>{TAG_GROUP_KIND_NAME[TAG_GROUP_KIND.MATERIAL_BASE]} 태그를 추가해주세요</span>
                  </Fragment>
                )}
              </div>
            </div>

            {tagLinkData[TAG_GROUP_KIND.MATERIAL_POST_EARRING] &&
            tagLinkData[TAG_GROUP_KIND.MATERIAL_POST_EARRING].length &&
            mainCategoryNameList.includes(PRODUCT_CATEGORY_NAME.EARRING) ? (
              <div>
                <div className="label">침소재</div>
                <div className="text">
                  <span>{tagLinkData[TAG_GROUP_KIND.MATERIAL_POST_EARRING].join(',')}</span>
                </div>
              </div>
            ) : null}

            {/* 소재/기타 태그 */}
            {isSelectMaterialEtcTag ? (
              <div>
                <div className="label">{TAG_GROUP_KIND_NAME[TAG_GROUP_KIND.MATERIAL_ETC]}</div>
                <div className="text">
                  {tagLinkData[TAG_GROUP_KIND.MATERIAL_ETC] && tagLinkData[TAG_GROUP_KIND.MATERIAL_ETC].length ? (
                    <span>{tagLinkData[TAG_GROUP_KIND.MATERIAL_ETC].join(',')}</span>
                  ) : (
                    <Fragment>
                      <span className="star">*</span>
                      <span>{TAG_GROUP_KIND_NAME[TAG_GROUP_KIND.MATERIAL_ETC]} 태그를 추가해주세요</span>
                    </Fragment>
                  )}
                </div>
              </div>
            ) : null}

            {/* 소재/도금 태그 */}
            {tagLinkData[TAG_GROUP_KIND.MATERIAL_PLATING] && tagLinkData[TAG_GROUP_KIND.MATERIAL_PLATING].length ? (
              <div>
                <div className="label">{TAG_GROUP_KIND_NAME[TAG_GROUP_KIND.MATERIAL_PLATING]}</div>
                <div className="text">
                  <span>{tagLinkData[TAG_GROUP_KIND.MATERIAL_PLATING].join(',')}</span>
                </div>
              </div>
            ) : null}

            {/* 소재/스톤 태그 */}
            {tagLinkData[TAG_GROUP_KIND.MATERIAL_STONE] && tagLinkData[TAG_GROUP_KIND.MATERIAL_STONE].length ? (
              <div>
                <div className="label">{TAG_GROUP_KIND_NAME[TAG_GROUP_KIND.MATERIAL_STONE]}</div>
                <div className="text">
                  <span>{tagLinkData[TAG_GROUP_KIND.MATERIAL_STONE].join(',')}</span>
                </div>
              </div>
            ) : null}

            {/* 컬러/패턴 태그 */}
            <div>
              <div className="label">{TAG_GROUP_KIND_NAME[TAG_GROUP_KIND.COLOR_PATTERN]}</div>
              <div className="text">
                {tagLinkData[TAG_GROUP_KIND.COLOR_PATTERN] && tagLinkData[TAG_GROUP_KIND.COLOR_PATTERN].length ? (
                  <span>{tagLinkData[TAG_GROUP_KIND.COLOR_PATTERN].join(',')}</span>
                ) : (
                  <Fragment>
                    <span className="star">*</span>
                    <span>{TAG_GROUP_KIND_NAME[TAG_GROUP_KIND.COLOR_PATTERN]} 태그를 추가해주세요</span>
                  </Fragment>
                )}
              </div>
            </div>

            {/* 모양 태그 */}
            {tagLinkData[TAG_GROUP_KIND.SHAPE] && tagLinkData[TAG_GROUP_KIND.SHAPE].length ? (
              <div>
                <div className="label">{TAG_GROUP_KIND_NAME[TAG_GROUP_KIND.SHAPE]}</div>
                <div className="text">
                  <span>{tagLinkData[TAG_GROUP_KIND.SHAPE].join(',')}</span>
                </div>
              </div>
            ) : null}

            {/* 체인 모양 태그 */}
            {tagLinkData[TAG_GROUP_KIND.CHAIN_SHAPE] &&
            tagLinkData[TAG_GROUP_KIND.CHAIN_SHAPE].length &&
            mainCategoryNameList.find((name) => AVAILABLE_CHAIN_SHAPE_TAG_CATEGORY_NAME_LIST.includes(name)) ? (
              <div>
                <div className="label">{TAG_GROUP_KIND_NAME[TAG_GROUP_KIND.CHAIN_SHAPE]}</div>
                <div className="text">
                  <span>{tagLinkData[TAG_GROUP_KIND.CHAIN_SHAPE].join(',')}</span>
                </div>
              </div>
            ) : null}

            {/* 시즌/상황 태그 */}
            {tagLinkData[TAG_GROUP_KIND.SEASON_STATUS] && tagLinkData[TAG_GROUP_KIND.SEASON_STATUS].length ? (
              <div>
                <div className="label">{TAG_GROUP_KIND_NAME[TAG_GROUP_KIND.SEASON_STATUS]}</div>
                <div className="text">
                  <span>{tagLinkData[TAG_GROUP_KIND.SEASON_STATUS].join(',')}</span>
                </div>
              </div>
            ) : null}

            <div>
              <div className="label">사이즈</div>
              <div className="text">
                {size ? (
                  <span>{size}</span>
                ) : (
                  <Fragment>
                    <span className="star">*</span>
                    <span>{size ? size : '사이즈를 추가해주세요'}</span>
                  </Fragment>
                )}
              </div>
            </div>

            <div>
              <div className="label">중량</div>
              <div className="text">
                <span>{setDash(weight)}</span>
              </div>
            </div>

            <div className="related-tag-list">
              <div className="title">관련태그</div>
              {relatedTagList.map((tagName, index) => (
                <div key={index} className="related-tag">
                  #{tagName}
                </div>
              ))}
            </div>
          </div>

          <div className="bar" />

          {/* 상품 상세 더보기 버튼 */}
          <div className="extra-info-toggle-area" onClick={() => extraToggle()}>
            {isShowExtra ? (
              <Img clickAble={false} src={extraInfoToggleUp} />
            ) : (
              <Img clickAble={false} src={extraInfoToggleDown} />
            )}
          </div>

          {isShowExtra && (
            <Fragment>
              <div className="extra-info-text">
                <span className="star">*</span>
                <span> 아몬즈 앱에서는 아래와 같이 보입니다</span>
              </div>

              {/* 배송 관련 안내 */}
              <div className="extra-form">
                <div className="title">배송 관련 안내</div>

                <div>
                  <div className="label">배송비</div>
                  <div className="text">아몬즈는 전상품 무료배송입니다.</div>
                </div>
                <div>
                  <div className="label">추가 배송비</div>
                  <div className="text">
                    제주 및 도서산간 지역은 배송비가 별도로 부과됩니다. <br />- 제주도 :{' '}
                    {setNumberWithComma(deliveryChargeJeju)}원 / 그 외 도서산간 지역 :{' '}
                    {setNumberWithComma(deliveryChargeEtc)}원
                  </div>
                </div>
              </div>

              <div className="bar" />

              {/* 반품 교환 안내 */}
              <div className="extra-form">
                <div className="title">반품 / 교환 안내</div>

                <div>
                  <div className="label">반품 / 교환 정보</div>
                  <div className="text">{setDash(memo)}</div>
                </div>

                <div>
                  <div className="label">반품 / 교환 시 유의사항</div>
                  <div className="sub-wrap">
                    <div className="text sub">- 단순 변심 또는 구매자의 사유로 인한 반품 시 :</div>
                    <div className="text detail">
                      해당 브랜드가 입력한 반송지에 <span>선불 택배</span>로 보내주세요.
                    </div>
                  </div>
                  <div className="sub-wrap">
                    <div className="text sub">- 제품의 하자나 브랜드의 과실로 인한 반품 시 :</div>
                    <div className="text detail">
                      해당 브랜드가 입력한 반송지에 <span>착불 택배</span>로 보내주세요.
                    </div>
                  </div>
                </div>

                <div>
                  <div className="label">반품 사유에 따른 환불정보</div>
                  <div className="sub-wrap">
                    <div className="text sub">- 단순 변심이나 구매자의 사유로 인한 반품 시 :</div>
                    <div className="text detail">
                      초기 배송비 <span>3,000원을 차감하여 환불</span>해드립니다.
                      <br />
                      (도서산간 지역의 경우, 도서산간 추가배송비 부과)
                    </div>
                  </div>
                  <div className="sub-wrap">
                    <div className="text sub">- 제품의 하자나 기타 브랜드의 과실로 인한 반품 시 :</div>
                    <div className="text detail">
                      <span>전액 환불</span>해드립니다.
                    </div>
                  </div>
                </div>

                <div>
                  <div className="label">교환 및 반품 시 보내실 곳</div>
                  <div className="text">{line1 && line2 ? `${line1}, ${line2}` : '-'}</div>
                </div>
              </div>

              <div className="bar" />

              {/* A/S 정보 */}
              <div className="extra-form">
                <div className="title">A/S 정보</div>

                <div>
                  <div className="label">A/S 안내</div>
                  <div className="text">{setDash(asInform)}</div>
                </div>
                <div>
                  <div className="label">착용시 주의 사항</div>
                  <div className="text">{setDash(caution)}</div>
                </div>
                <div>
                  <div className="label">품질보증 기준</div>
                  <div className="text">{setDash(qualityAssurance)}</div>
                </div>
                <div>
                  <div className="label">제조자 / 제조국</div>
                  <div className="text">{manufacturer && origin ? `${manufacturer} / ${origin}` : '-'}</div>
                </div>
              </div>

              <div className="bar" />

              {/* 브랜드 연락처 */}
              <div className="extra-form">
                <div className="title">브랜드 연락처</div>

                <div>
                  <div className="label">고객센터 전화번호</div>
                  <div className="text">
                    {asPhone ? setPhoneFormat(asPhone) : storePhone ? setPhoneFormat(storePhone) : '-'}
                  </div>
                </div>
                <div>
                  <div className="label">카카오톡 플러스친구</div>
                  <div className="text">{setDash(kakaoAccount)}</div>
                </div>
              </div>
            </Fragment>
          )}
        </div>

        {/* 버튼 영역(고정) */}
        <div className="fixed-btn-area">
          <div>
            <AiOutlineUpload className="share-btn" />
            <div className="like-btn-area">
              <AiOutlineHeart className="heart-btn" />
              <span>{setNumberWithComma(likeCount ? likeCount : 0)}</span>
            </div>
          </div>
          <button className="buy-btn">구매하기</button>
        </div>
      </div>

      {isShowDeliveryInfoLayer ? (
        <div className="delivery-type-info">
          <div className="delivery-type-info-close">
            <span>
              <CloseOutlined onClick={() => deliveryInfoLayerToggle()} />
            </span>
          </div>

          {setDeliveryTypeInfoContent({
            isTodayDelivery,
            deliveryType,
            orderMadeDate,
            directDeliveryTimeLimit,
          })}
        </div>
      ) : null}
    </Fragment>
  );
};

export default PreviewProductDetail;
